// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/NewsBlock/NewsBlock.sass
// module id = 439
// module chunks = 0